/*
Documentation

this is the footer for the dashboard layout

*/

import React from "react";
import { Link } from 'react-router-dom';
import { Col, Container, Nav, NavItem, Row } from "reactstrap";
import keys from 'keys'
import A from 'components/markup/links/A'

const Footer = () => (
    <div id="dashboard-footer" className="footer-wrapper">
        <Container fluid>
            <footer className="footer">
                <Row className="align-items-center justify-content-lg-between">

                    <Col lg="6">
                        <div className="copyright text-center text-lg-left my-4 my-md-0">
                            © {new Date().getFullYear()}{' '}
                            {keys.COMPANY}
                            {' '}&mdash;{' '}
                            <a className="font-weight-bold ml-1 " href="https://architeck.io" rel="noopener noreferrer" target="_blank">
                                Software Built By Zap Reports LLC
                            </a>
                        </div>
                    </Col>

                    <Col lg="6">

                        <Nav className="nav-footer justify-content-center justify-content-lg-end">

                            <NavItem>
                                <Link className=" nav-link" to="/dashboard/settings">My Profile</Link>
                            </NavItem>

                            <NavItem>
                                <A className=" nav-link" to={`${keys.SITE_URL}/legal/terms-of-service`}>Terms Of Service</A>
                            </NavItem>
                            <NavItem>
                                <A className=" nav-link" to={`${keys.SITE_URL}/legal/privacy-policy`}>Privacy</A>
                            </NavItem>

                            <NavItem>
                                <Link className=" nav-link" href="logout" to="/auth/logout">Logout</Link>
                            </NavItem>

                        </Nav>

                    </Col>

                </Row>
            </footer>

        </Container>
    </div>
)

export default Footer;
